module.exports = __webpack_public_path__ + "static/media/logo_away.3c71088a.png";